// eslint-disable-next-line import/no-unresolved
const base = require('onestic-base/components/preHome');
const createTrapFocus = require('onestic-base/components/accessibility/focusTrap');

const trapPrehomeFocus = (prehomeModal) => {
    if (typeof prehomeModal.data('releaseFocus') !== 'function') {
        const releaseFocus = createTrapFocus.trapFocus(prehomeModal, () => {
            prehomeModal.find('.icon-cross-line').trigger('click');
        });
        prehomeModal.data('releaseFocus', releaseFocus);
    }
};

const releasePrehomeFocus = (prehomeModal) => {
    const releaseFocus = prehomeModal.data('releaseFocus');
    if (typeof releaseFocus === 'function') {
        releaseFocus();
    }
    prehomeModal.data('releaseFocus', null);
};

const showPrehome = (prehomeModal) => {
    if (prehomeModal.hasClass('cta-bar-container')) {
        prehomeModal.show();
    } else {
        prehomeModal.modal();
        trapPrehomeFocus(prehomeModal);
    }
};

const preHomeModalCode = () => {
    const prehomeModal = $('#preHome');
    base.methods.preHomeModalCode();
    if (prehomeModal.length && prehomeModal.hasClass('preHomeActive')) {
        trapPrehomeFocus(prehomeModal);
    }
};

function myAjax(myResponse, pushState) {
    const preHomeButton = $('.prehomebutton');
    const languageSelector = $('#preHome #language');

    const countrySelector = $('#preHome #countrySite');
    const countrySelectorContent = countrySelector.parent().parent();
    const languageSelectorContent = languageSelector.parent().parent();

    if (pushState) {
        if (myResponse.html) {
            languageSelector.html(myResponse.html);
            if (countrySelectorContent && countrySelectorContent.hasClass('col-12')) {
                countrySelectorContent.removeClass('col-12').addClass('col-6');
            }

            if (languageSelectorContent && languageSelectorContent.hasClass('d-none')) {
                languageSelectorContent.removeClass('d-none');
            }
        } else {
            if (countrySelectorContent && countrySelectorContent.hasClass('col-6')) {
                countrySelectorContent.removeClass('col-6').addClass('col-12');
            }
            if (languageSelectorContent && !languageSelectorContent.hasClass('d-none')) {
                languageSelectorContent.addClass('d-none');
            }
        }
    }

    $('.title-container').find('span').text(myResponse.prehomeTitle);
    preHomeButton.attr('data-url', myResponse.url);

    preHomeButton.val(myResponse.prehomeAccept);
    preHomeButton.find('span').text(myResponse.prehomeAccept);
}

const footerSelectorEvents = () => {
    const languageSelector = $('#languageFooter');
    const countrySelector = $('#countrySiteFooter');

    countrySelector.on('change', (e) => {
        const prehomeModal = $('#preHome');
        const countrySelected = $('#countrySiteFooter option:selected');

        if (prehomeModal.length) {
            const countryModal = prehomeModal.find('#countrySite');
            const result = base.methods.loadLanguagesforCountry(e);

            showPrehome(prehomeModal);
            countryModal.val(countrySelected.data('country-code'));

            $('#countrySite option').removeAttr('selected');
            $(`#countrySite option[data-countryandstate='${countrySelected.attr('data-countryandstate')}']`).attr('selected', 'selected');

            $.ajax({
                url: result.urli,
                data: result.datAjax,
                method: 'GET',
            }).done((response) => {
                myAjax(response, true);
            });
        }
    });

    languageSelector.on('change', (e) => {
        const url = $(e.target).find('option:selected').data('url');
        if (url) {
            const countrySelected = $('#countrySiteFooter option:selected');
            const localeSelected = $(e.target).find('option:selected').val();
            base.methods.updateCountryLocale(
                $('#countrySiteFooter').data('urlcountry'),
                localeSelected,
                countrySelected.attr('data-country-code'),
                url,
            );
        }
    });
};

const modalSelectorEvents = () => {
    const languageSelector = $('#preHome #language');
    const countrySelector = $('#countrySite');

    countrySelector.on('change', (e) => {
        const result = base.methods.loadLanguagesforCountry(e);
        $.ajax({
            url: result.urli,
            data: result.datAjax,
            method: 'GET',
        }).done((response) => {
            myAjax(response, true);
        });
    });

    languageSelector.on('change', (e) => {
        const prehomeButton = $('.prehomebutton');
        if (prehomeButton.length) {
            const languageSelected = $('#language option:selected').val();
            const countrySelected = $('#countrySite option:selected');
            const urli = $('#countrySite').data('url');
            const datAjax = {
                format: 'ajax',
                locale: languageSelected,
                countryCode: countrySelected.data('country-code'),
                countryselect: true,
                action: prehomeButton.data('action'),
                querystring: prehomeButton.data('querystring'),
                countryAndState: countrySelected.attr('data-countryAndState'),
            };

            prehomeButton.data(
                'url',
                $(e.target).find('option:selected').data('url'),
            );

            $.ajax({
                url: urli,
                data: datAjax,
                method: 'GET',
            }).done((response) => {
                myAjax(response, false);
            });
        } else {
            const languageSelected = $('#language option:selected');
            base.methods.updateCountryLocale(
                $('#countrySiteFooter').data('urlcountry'),
                languageSelected.val(),
                languageSelected.attr('data-country-code'),
                $('#language option:selected').data('url'),
            );
        }
    });

    $('.prehomebutton').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const externalRedirection = $('#countrySite option:selected').data(
            'external-redirect',
        );
        const thisTarget = $(e.currentTarget);
        if (externalRedirection) {
            window.location.href = externalRedirection;
        } else {
            const url = !$('.prehomebutton').attr('data-url') ? $('#countrySite option:selected').data('url') : $('.prehomebutton').attr('data-url');

            if (url !== undefined) {
                const modal = thisTarget.closest('#preHome');

                base.methods.updateCountryLocale(
                    $('#countrySite').data('urlcountry'),
                    modal.find('#language option:selected').val(),
                    $('#countrySite option:selected').attr('data-country-code'),
                    url,
                );
            } else {
                window.location.reload();
            }
        }
    });

    $('#preHome').on('click', '.icon-cross-line', () => {
        releasePrehomeFocus($('#preHome'));
        $('#preHome').hide();
    });
};
module.exports = {
    methods: {
        preHomeModalCode,
        footerSelectorEvents,
        modalSelectorEvents,
        myAjax,
        loadLanguagesforCountry: base.methods.loadLanguagesforCountry,
        updateCountryLocale: base.methods.updateCountryLocale,
    },
    initialLoad: base.initialLoad(),
    loadSelector() {
        preHomeModalCode();
        footerSelectorEvents();
        modalSelectorEvents();
    },
};
